import areaSqM from '@turf/area'
import { Feature, Geometry, MultiPolygon } from 'geojson'
import { sum } from 'ramda'
import { SQUARE_METERS_PER_ACRE } from '../numeralConsts'

export const getFeatureAcres = (features: (Feature<Geometry, any> | MultiPolygon)[]) => {
  const area = sum(features.map(feature => areaSqM(feature))) / SQUARE_METERS_PER_ACRE
  return area
}
